<script>
  import { onMount, onDestroy } from "svelte";
  import { createEventDispatcher } from "svelte";
  import QuizFieldOptions from "./QuizFieldOptions.svelte";
  import {External, M} from "../../external";

  export let step,
    steps = [];

  let sortable, jqSortable;

  const dispatch = createEventDispatcher();

  let onShowSteps = () => {
    dispatch("back");
  };

  let onChange = () => {
    dispatch("change");
  };

  let editStepSettings = () => {
    dispatch("editStepSettings", {
      step: step
    });
  };

  let addField = (event) => {
    External.FormFields.addField(
      External.$(event.target),
      step.fields,
      {
        availableFields: External.FormFields.ALL_FORM_FIELDS,
        allowQuizFields: true,
        allowBuiltInProperties: true,
        disabledProperties: []
      },
      (field) => {
        step.fields = step.fields;
        onChange();
      }
    );
  };

  let deleteField = (idx) => {
    External.Tools.prompt(M.DELETE, M.DEL_CONFIRM, () => {
      step.fields.splice(idx, 1);
      step.fields = step.fields;
      onChange();
    });
  };

  let editField = (idx) => {
    let field = step.fields[idx];
    let canChangeStyle = field.type === "select" || field.type === "radio" || field.type === "checkbox";
    External.FormFields.editFormField(field, canChangeStyle, false, () => {
      let currentField = Object.assign({}, field);
      if (currentField.type === "hidden") External.Widgets.markWithDynamicData(currentField, ["fieldValue"]);
      step.fields[idx] = currentField;
      onChange();
    });
  };

  let resizeField = (idx) => {
    let field = step.fields[idx];
    field.small = field.small === 1 ? 0 : 1;
    step.fields[idx] = field;
    onChange();
  };

  let onFieldNameChange = (idx) => {
    if (step.fields[idx].property) {
      step.fields[idx].customLabel = true;
    }
    onChange();
  };

  let hasFieldOptions = (field) => {
    if (field.property) {
      let property = External.getById(External.Website.crmProperties, field.property);
      if (property && property.name === "accept_terms") {
        return false;
      }
    }
    return field.type === "select" || field.type === "radio" || field.type === "checkbox";
  };

  onMount(() => {
    if (!step.id) {
      step.id = Math.random();
    }
    jqSortable = External.$(sortable);
    jqSortable.sortable({
      items: ".option-field-wrapper",
      handle: ".field-move",
      containment: "parent",
      tolerance: "pointer",
      axis: "y",
      start: (event, ui) => {
        ui.item.data("idx", ui.item.index());
      },
      stop: (event, ui) => {
        let newIdx = ui.item.index();
        let oldIdx = ui.item.data("idx") || 0;
        if (newIdx != oldIdx) {
          let elem = step.fields[oldIdx];
          step.fields.splice(oldIdx, 1);
          step.fields.splice(newIdx, 0, elem);
          step.fields = step.fields;
          onChange();
        }
      }
    });
  });

  onDestroy(function () {
    jqSortable.sortable("destroy");
    jqSortable = null;
  });
</script>

<div class="col20 f-left relative">
  <div class="help-text-wrapper">
    <h3 class="col20 f-left t-center mb-5 mt-10" style="padding: 0 35px; box-sizing: border-box;">{step.name}</h3>
  </div>

  <a class="back-arrow rounded-back-arrow" style="left:0;" on:click={onShowSteps} />

  <div class="col20 mt-25 mb-5 f-left gray-section product-select-wrapper">
    <div class="col20 f-left ab-step center-vertically">
      <h4 class="roboto">{M.STEP_HEADING_AND_DESC}</h4>
      <a class="text-link blue-text" on:click={(event) => editStepSettings(event)}>
        {M.CHANGE}
      </a>
    </div>
  </div>

  <span class="help-text mb-15">{M.EDIT_YOUR_FORM_BELOW}</span>

  <div class="col20 f-left" bind:this={sortable}>
    {#if step.fields.length === 0}
      <div class="col20 f-left">
        <div class="form-wrapper">
          <h4 class="col20 f-left ta-center">{M.NO_FIELDS_YET}</h4>
        </div>
      </div>
    {:else}
      {#each step.fields as field, idx (field)}
        <div class="option-field-wrapper col20 f-left">
          <div class="field col20 f-left field-type-{field.type}">
            <span class="field-move move-icon button-tooltip" data-tooltip="simpleMove" />
            <input
              type="text"
              name="fieldName"
              class="label-field"
              readonly={field.type === "recaptcha" ? "readonly" : null}
              bind:value={field.name}
              on:blur={() => onFieldNameChange(idx)} />
            <div class="buttons-wrapper flex-none">
              {#if field.type !== "recaptcha"}
                <a data-tooltip="simpleEdit" class="middle-button blue ml-10" on:click={() => editField(idx)}>
                  {M.SETTINGS}
                </a>
              {/if}
              <a
                data-tooltip="simpleResize"
                class="delete resize-icon light-gray-icon modify button-tooltip
                circle-effect"
                on:click={() => resizeField(idx)}>
                {#if field.small === 1}
                  <i class="material-icons-outlined">unfold_more</i>
                {:else}
                  <i class="material-icons-outlined">unfold_less</i>
                {/if}
              </a>
              <a
                data-tooltip="simpleDelete"
                class="delete delete-icon light-gray-icon modify button-tooltip
                mr-10 circle-effect"
                on:click={() => deleteField(idx)}>
                <i class="material-icons-outlined">delete</i>
              </a>
            </div>
          </div>
          {#if hasFieldOptions(field)}
            <QuizFieldOptions field={field} onChange={onChange} steps={steps} />
          {/if}
        </div>
      {/each}
    {/if}
  </div>
  <div class="col20 f-left mt-15">
    <a class="middle-button blue with-icon" style="margin-left:5px;" title={M.ADD_FIELD} on:click={(event) => addField(event)}>
      {M.ADD_FIELD}
    </a>
  </div>
</div>
